<p class="alert alert-danger" *ngIf="networkError" style="z-index: 1000">
  Пропало соедение с интернетом, приложение может работать с ошибками. <u style="cursor: pointer" (click)="reload()">Обновите страницу</u>
</p>
